import { theme } from "@answersnow/pkg-theme";
import type { SxProps, Theme } from "@mui/material/styles";

// Spacing
export const space2 = theme.spacing(2); // 6px
export const space3 = theme.spacing(3); // 8px
export const space4 = theme.spacing(4); // 12px
export const space5 = theme.spacing(5); // 16px
export const space6 = theme.spacing(6); // 20px
export const space7 = theme.spacing(7); // 24px
export const space10 = theme.spacing(10); // 40px

const grey50 = theme.palette.default.hover;
const panelWidth = 600;

export const description: SxProps<Theme> = {
  paddingTop: space2,
  paddingBottom: space5,
};

export const assessmentCard: SxProps<Theme> = {
  backgroundColor: grey50,
  borderRadius: "16px",
  padding: space3,
};

export const assessmentCardData: SxProps<Theme> = {
  backgroundColor: theme.palette.default.background,
  borderRadius: "12px",
  boxShadow: "0 6px 14px rgba(16, 24, 40, 0.12)",
  border: `1px solid ${theme.palette.divider}`,
  overflow: "hidden",
};

export const innerCard: SxProps<Theme> = {
  backgroundColor: theme.palette.default.background,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.radius.large,
  boxShadow: `0px 1px 1px 0px rgba(0, 0, 0, 0.15)`,
  paddingX: space7,
  paddingY: space5,
  marginBottom: space2,
};

export const averageStatistics: SxProps<Theme> = {
  m: space6,
  marginTop: space5,
};

export const previousPaper = {
  width: { xs: "100%", md: panelWidth },
  padding: space7,
  position: "fixed",
  right: 0,
  top: 0,
  height: "100vh",
  overflowY: "auto",
  overscrollBehavior: "contain",
};

export const panelHeader: SxProps<Theme> = {
  marginLeft: "-3px",
  "& .MuiPaginationItem-root": {
    borderRadius: "6px",
  },
  "& li button:not(.MuiPaginationItem-previousNext, MuiPaginationItem-previousNext)": {
    display: "none",
  },
};

export const domainScore: SxProps<Theme> = {
  marginTop: space5,
  columnGap: "15px",
  rowGap: "13px",
  columns: 12,
};

export const historyIcon: SxProps<Theme> = {
  marginRight: space3,
  lineHeight: 1,
  verticalAlign: "bottom",
};
